import { render, staticRenderFns } from "./CustomerProductOrdersList.vue?vue&type=template&id=10bcfe2a&scoped=true&"
import script from "./CustomerProductOrdersList.vue?vue&type=script&lang=js&"
export * from "./CustomerProductOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerProductOrdersList.vue?vue&type=style&index=0&id=10bcfe2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bcfe2a",
  null
  
)

export default component.exports